import SalaryData from "../../entities/SalaryData";

export const setUserId = (userId: string) => {
  return {
    type: SET_USER_ID,
    payload: userId,
  };
};

export const setIsEnteredFromToShowFile = (userId: boolean) => {
  return {
    type: SET_IS_ENTERED_FROM_TO_SHOW_FILE,
    payload: userId,
  };
};

export const setIssueDate = (issueDate: Date | string) => {
  return {
    type: SET_ISSUE_DATE,
    payload: issueDate,
  };
};

export const setIsValidAndNotUser = ( isValidAndNotUser: boolean) => {
  return {
    type: SET_IS_VALID_AND_NOT_MEMEBER,
    payload: isValidAndNotUser,
  };
};


export const setIsOnline = (isOnline: boolean) => {
  return {
    type: SET_IS_ONLINE,
    payload: isOnline,
  };
};

export const setUserFunds = (userFunds: any) => {
  return {
    type: SET_USER_FUNDS,
    payload: userFunds,
  };
};

export const setMapUserFunds = (mapUserFunds: any) => {
  return {
    type: SET_MAP_USER_FUNDS,
    payload: mapUserFunds,
  };
};

export const setUserFirstName = (firstName: string) => {
  return {
    type: SET_FIRST_NAME,
    payload: firstName,
  };
};

export const setUserLastName = (lastName: string) => {
  return {
    type: SET_LAST_NAME,
    payload: lastName,
  };
};

export const setIsAmit = (isAmit: boolean) => {
  return {
    type: SET_IS_AMIT,
    payload: isAmit,
  };
};

export const setIsPensioner = (isPensioner: boolean) => {
  return {
    type: SET_IS_PENSIONER,
    payload: isPensioner,
  };
};

export const setIs101ButtonAllowed = (is101ButtonAllowed: boolean) => {
  return {
    type: SET_IS_101_BUTTON_ALLOWED,
    payload: is101ButtonAllowed,
  };
};

export const set101Url = (url101: boolean) => {
  return {
    type: SET_101_Url,
    payload: url101,
  };
};


export const setIsSuspend = (isSuspend: boolean) => {
  return {
    type: SET_IS_SUSPEND,
    payload: isSuspend,
  };
};

export const sethaveYearlyReports = (isSuspend: boolean) => {
  return {
    type: HAVE_YEAR_REPORTS,
    payload: isSuspend,
  };
};

export const setMifneFunds = (MifneFunds: object) => {
  return {
    type: SET_MIFNE_FUNDS,
    payload: MifneFunds,
  };
};


export const setIsSendAgainPossible = (isPossible: boolean) => {
  return {
    type: SET_IS_SEND_AGAIN_POSSIBLE,
    payload: isPossible,
  };
};


export const setIsSendAgainPossibleDate = (isPossibleDate: Date) => {
  return {
    type: SET_IS_SEND_AGAIN_POSSIBLE_DATE,
    payload: isPossibleDate,
  };
};

export const setHaveMessages = (haveMessages: boolean) => {
  return {
    type: SET_HAVE_MESSAGES,
    payload: haveMessages,
  };
};

export const setIdDate = (idDate: string) => {
  return {
    type: SET_ID_DATE,
    payload: idDate,
  };
};

export const setpensionTypeDesc = (pensionTypeDesc: string) => {
  return {
    type: SET_PENTION_TYPE_DESC,
    payload: pensionTypeDesc,
  };
};



export const setSalaryDataRedux = (salaryDataRedux: any) => {
  return {
    type: SET_SALARY_DATA_REDUX,
    payload: salaryDataRedux,
  };
};


export const setpensionTypeDescHeader = (pensionTypeDescHeader: any[]) => {
  return {
    type: SET_PENSION_TYPE_DESC_HEADER,
    payload: pensionTypeDescHeader,
  };
};

export const setIsFileFound = (isExsists: boolean) => {
  return {
    type: IS_FILE_FOUND,
    payload: isExsists,
  };
};

export const pensionTypeDescCounter = (pensionTypeDescCounter: any[]) => {
  return {
    type: SET_PENTION_TYPE_DESC_COUNTER,
    payload: pensionTypeDescCounter,
  };
};



export const resetUser = () => {
  return {
    type: RESET_USER,
  };
};



export const SET_IS_SUSPEND_AUTO_TURN_OFF = "SET_IS_SUSPEND_AUTO_TURN_OFF";
export const SET_USER_ID = "SET_USER_ID";
export const SET_IS_SUSPEND = "SET_IS_SUSPEND";
export const HAVE_YEAR_REPORTS = "HAVE_YEAR_REPORTS";
export const SET_MIFNE_FUNDS='SET_MIFNE_FUNDS';
export const SET_IS_ONLINE = "SET_IS_ONLINE";
export const SET_USER_FUNDS = "SET_USER_FUNDS";
export const SET_MAP_USER_FUNDS = "SET_MAP_USER_FUNDS";
export const SET_FIRST_NAME = "SET_FIRST_NAME";
export const SET_LAST_NAME = "SET_LAST_NAME";
export const SET_IS_AMIT = "SET_IS_AMIT";
export const SET_IS_PENSIONER = "SET_IS_PENSIONER";
export const SET_IS_101_BUTTON_ALLOWED = "SET_IS_101_BUTTON_ALLOWED";
export const SET_101_Url = "SET_101_Url";
export const SET_HAVE_MESSAGES = "SET_HAVE_MESSAGES";
export const SET_ID_DATE = "SET_ID_DATE";
export const SET_IS_SEND_AGAIN_POSSIBLE = "SET_IS_SEND_AGAIN_POSSIBLE";
export const SET_IS_SEND_AGAIN_POSSIBLE_DATE = "SET_IS_SEND_AGAIN_POSSIBLE_DATE";
export const SET_PENTION_TYPE_DESC = "SET_PENTION_TYPE_DESC";
export const RESET_USER = "RESET_USER";
export const SET_SALARY_DATA_REDUX = "SET_SALARY_DATA_REDUX";
export const SET_PENSION_TYPE_DESC_HEADER = "SET_PENSION_TYPE_DESC_HEADER";
export const SET_PENTION_TYPE_DESC_COUNTER = "SET_PENTION_TYPE_DESC_COUNTER";
export const IS_FILE_FOUND = "IS_FILE_FOUND";
export const SET_IS_ENTERED_FROM_TO_SHOW_FILE = "SET_IS_ENTERED_FROM_TO_SHOW_FILE";
export const SET_ISSUE_DATE = "SET_ISSUE_DATE";
export const SET_IS_VALID_AND_NOT_MEMEBER = "SET_IS_VALID_AND_NOT_MEMEBER";


